import { rankingItems } from "@/mocks/home";

const trendMap: Record<string, { icon: string; color: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function HotRanking() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-foreground-950">实时热榜</h3>
        <span className="font-label text-xs text-foreground-500">每分钟更新</span>
      </div>

      <ol className="mt-4 divide-y divide-background-200">
        {rankingItems.map((item) => (
          <li key={item.rank} className="flex items-start gap-3 py-3">
            <span
              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                item.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {item.rank}
            </span>
            <div className="min-w-0 flex-1">
              <a
                href="#topics"
                className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-600"
              >
                {item.title}
              </a>
              <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                <span>热度 {item.heat}</span>
                <span className={`flex h-4 w-4 items-center justify-center ${trendMap[item.trend].color}`}>
                  <i className={`${trendMap[item.trend].icon} text-sm`} />
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>

      <a
        href="#topics"
        className="mt-2 flex items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        查看完整热度榜
        <i className="ri-arrow-right-line" />
      </a>
    </div>
  );
}